import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "image-content"
};
const _hoisted_2 = {
    class: "delete-icon"
};
const _hoisted_3 = [
    "onClick"
];
const _hoisted_4 = {
    class: "delete-icon"
};
import config from "@/config/upload";
import { ref, watch, computed } from "vue";
import { useFormItem } from "element-plus";
import { debugWarn } from "element-plus/es/utils/error";

import { ElMessage, ElNotification } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/notification/style/css';
export default {
    __name: 'index',
    props: {
        modelValue: {
            type: [
                String,
                Array
            ],
            default: ""
        },
        max: {
            type: [
                String,
                Number
            ],
            default: 10
        },
        size: {
            type: [
                String,
                Number
            ],
            default: 60
        },
        width: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        height: {
            type: [
                String,
                Number
            ],
            default: 0
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: "image/gif, image/jpeg, image/png"
        },
        apiObj: {
            type: Object,
            default: ()=>{}
        },
        name: {
            type: String,
            default: config.filename
        },
        data: {
            type: Object,
            default: ()=>{}
        },
        maxSize: {
            type: Number,
            default: config.maxSizeFile
        },
        limit: {
            type: Number,
            default: 0
        },
        onSuccess: {
            type: Function,
            default: ()=>{
                return true;
            }
        }
    },
    emits: [
        "update:modelValue",
        "success",
        "closed"
    ],
    setup (__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const customStyle = computed(()=>{
            return {
                width: `${props.width || props.size}px`,
                height: `${props.height || props.size}px`
            };
        });
        const fileData = computed({
            get: ()=>props.modelValue,
            set: (val)=>emit('update:modelValue', val)
        });
        const { formItem } = useFormItem();
        watch(()=>props.modelValue, (newVal)=>{
            formItem?.validate('change').catch((err)=>debugWarn(err));
        });
        const fileList = ref([]);
        const before = (file)=>{
            const maxSize = file.size / 1024 / 1024 < props.maxSize;
            if (!maxSize) {
                ElMessage.warning(`上传文件大小不能超过 ${props.maxSize}MB!`);
                return false;
            }
        };
        const success = (res, file)=>{
            let os = props.onSuccess(res, file);
            if (os != undefined && os == false) {
                return false;
            }
            let response = config.parseData(res);
            if (props.multiple) {
                if (fileData.value.length < props.max) {
                    fileData.value.push(response.src);
                }
            } else {
                fileData.value = response.src;
            }
        };
        const error = (err)=>{
            ElNotification.error({
                title: "上传文件未成功",
                message: err
            });
        };
        const request = (param)=>{
            var apiObj = config.apiObjFile;
            if (props.apiObj) {
                apiObj = props.apiObj;
            }
            const data = new FormData();
            data.append(param.filename, param.file);
            for(const key in param.data){
                data.append(key, param.data[key]);
            }
            apiObj.post(data, {
                onUploadProgress: (e)=>{
                    const complete = parseInt(e.loaded / e.total * 100 | 0, 10);
                    param.onProgress({
                        percent: complete
                    });
                }
            }).then((res)=>{
                var response = config.parseData(res);
                if (response.code == config.successCode) {
                    param.onSuccess(res);
                } else {
                    param.onError(response.msg || "未知错误");
                }
            }).catch((err)=>{
                param.onError(err);
            });
        };
        const handleExceed = ()=>{
            ElMessage.warning(`当前设置最多上传 ${props.limit} 个文件，请移除后上传!`);
        };
        const handlerRemove = (index, isMultiple = false)=>{
            if (isMultiple) {
                (Array.isArray(fileData.value) ? fileData.value : []).splice(index, 1);
                fileData.value = [
                    ...fileData.value
                ];
            } else {
                fileData.value = "";
            }
        };
        return (_ctx, _cache)=>{
            const _component_el_image = _resolveComponent("el-image");
            const _component_el_icon_delete = _resolveComponent("el-icon-delete");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_ElIconPlus = _resolveComponent("ElIconPlus");
            const _component_el_upload = _resolveComponent("el-upload");
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                __props.multiple ? (_openBlock(), _createElementBlock(_Fragment, {
                    key: 0
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileData.value, (item, index)=>{
                        return _openBlock(), _createElementBlock("div", {
                            class: "imageBtn",
                            style: _normalizeStyle(customStyle.value),
                            key: index
                        }, [
                            _createVNode(_component_el_image, {
                                style: {
                                    "width": "100%",
                                    "height": "100%"
                                },
                                "initial-index": index,
                                "preview-src-list": fileData.value,
                                src: item,
                                fit: "cover",
                                "preview-teleported": ""
                            }, null, 8, [
                                "initial-index",
                                "preview-src-list",
                                "src"
                            ]),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("span", {
                                    class: "del",
                                    onClick: _withModifiers(($event)=>handlerRemove(index, true), [
                                        "stop"
                                    ])
                                }, [
                                    _createVNode(_component_el_icon, null, {
                                        default: _withCtx(()=>[
                                                _createVNode(_component_el_icon_delete)
                                            ]),
                                        _: 1
                                    })
                                ], 8, _hoisted_3)
                            ])
                        ], 4);
                    }), 128)),
                    fileData.value.length < __props.max ? (_openBlock(), _createBlock(_component_el_upload, {
                        key: 0,
                        "file-list": fileList.value,
                        "onUpdate:fileList": _cache[0] || (_cache[0] = ($event)=>fileList.value = $event),
                        accept: __props.accept,
                        multiple: "",
                        style: _normalizeStyle(customStyle.value),
                        name: __props.name,
                        drag: "",
                        showFileList: false,
                        "http-request": request,
                        data: __props.data,
                        action: "",
                        "before-upload": before,
                        "on-success": success,
                        "on-error": error,
                        "on-exceed": handleExceed
                    }, {
                        default: _withCtx(()=>[
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_ElIconPlus)
                                        ]),
                                    _: 1
                                })
                            ]),
                        _: 1
                    }, 8, [
                        "file-list",
                        "accept",
                        "style",
                        "name",
                        "data"
                    ])) : _createCommentVNode("", true)
                ], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
                    key: 1
                }, [
                    fileData.value ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "imageBtn",
                        style: _normalizeStyle(Object.assign({
                            margin: 0
                        }, customStyle.value))
                    }, [
                        _createVNode(_component_el_image, {
                            style: {
                                "width": "100%",
                                "height": "100%"
                            },
                            src: fileData.value,
                            "preview-src-list": [
                                fileData.value
                            ],
                            fit: "cover",
                            "preview-teleported": ""
                        }, null, 8, [
                            "src",
                            "preview-src-list"
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", {
                                class: "del",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event)=>handlerRemove('', false), [
                                    "stop"
                                ]))
                            }, [
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_el_icon_delete)
                                        ]),
                                    _: 1
                                })
                            ])
                        ])
                    ], 4)) : (_openBlock(), _createBlock(_component_el_upload, {
                        key: 1,
                        "file-list": fileList.value,
                        "onUpdate:fileList": _cache[2] || (_cache[2] = ($event)=>fileList.value = $event),
                        accept: __props.accept,
                        style: _normalizeStyle(customStyle.value),
                        name: __props.name,
                        drag: "",
                        showFileList: false,
                        "http-request": request,
                        data: __props.data,
                        action: "",
                        "before-upload": before,
                        "on-success": success,
                        "on-error": error,
                        "on-exceed": handleExceed
                    }, {
                        default: _withCtx(()=>[
                                _createVNode(_component_el_icon, null, {
                                    default: _withCtx(()=>[
                                            _createVNode(_component_ElIconPlus)
                                        ]),
                                    _: 1
                                })
                            ]),
                        _: 1
                    }, 8, [
                        "file-list",
                        "accept",
                        "style",
                        "name",
                        "data"
                    ]))
                ], 64))
            ]);
        };
    }
};
